import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { role } from "../../Roles/RolesSlice";

// Models
export interface addUserFields {
    email?: string;
    password?: string;
    employee?: { name: string; id: number; };
    role?: role;
}

// Add user state
export interface addUserState {
    fields: addUserFields,
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialAddUserState: addUserState = {
    fields: {
        email: "",
        password: "",
        role: {
            id: 0,
            name: ""
        }
    },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const addUserSlice = createSlice({
    name: 'add_user',
    initialState: initialAddUserState,
    reducers: {
        init: state => initialAddUserState,
        set: ( state, {payload}: PayloadAction<addUserFields> ) => {
            state.fields = { ...state.fields, ...payload }
        },
        setEditId: ( state, {payload}: PayloadAction<number> ) => {
            state.editId = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
    }
})